import React, { Component } from 'react';
import { connect } from 'react-redux';

import PaypalOptions from './PaypalOptions/PaypalOptions';
import PaypalFooter from './PaypalFooter/PaypalFooter';
import Button from '../../UI/Button/Button';

import { setAmountDetails } from '../../../store/actions/index';

class Paypal extends Component {

    componentWillMount() {
        this.props.onSetAmountDetails(this.props.paypalPayment.PAYPAL);
    }

    render() {
        return (
            <React.Fragment>
                <div className={`mb-6`}>
                    <PaypalOptions/>
                </div>
                <div className={`u-flex justify-content-between align-items-center mt-auto phone-f-column`}>
                    <div className={`u-phoneWidth100Percent phone-mb-4`}>
                        <PaypalFooter/>
                    </div>
                    <div className={`u-phone-width100Percent`}> 
                        <Button onClick={this.props.clicked} theme='Primary' type='Pay'>Pay Now</Button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        paypalPayment: state.payments.bookingDetails.agentPaymentOptions.amountDetails.PAYPAL
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetAmountDetails: (val) => dispatch(setAmountDetails(val))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Paypal);


// WEBPACK FOOTER //
// ./src/components/Payment/Paypal/Paypal.js